Object.defineProperty(exports,"__esModule",{value:true});var _StyleRegistry=require('./StyleRegistry');var _StyleRegistry2=_interopRequireDefault(_StyleRegistry);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var registry=new _StyleRegistry2.default();exports.default=registry;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-native-web/dist/apis/StyleSheet/registry.js
 ** module id = 208
 ** module chunks = 0
 **/